import { render, staticRenderFns } from "./FixedView.vue?vue&type=template&id=3c13d8fe"
import script from "./FixedView.vue?vue&type=script&lang=js"
export * from "./FixedView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports